var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_20666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 21,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_20666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19_20666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.704 7.88281H25.7706L19.0706 15.5411L26.9531 25.9603H20.7815L15.9481 19.6403L10.4165 25.9603H7.34813L14.5148 17.7686L6.95312 7.88365H13.2815L17.6506 13.6603L22.704 7.88281ZM21.6281 24.1253H23.3273L12.3581 9.62198H10.5348L21.6281 24.1253Z",
    fill: "black"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_20666)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95312,
    y: 6.92188,
    width: 20,
    height: 20,
    fill: "#E2E8F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_20666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.95312 6.92188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19_20666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.95312 6.92188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.ed2349a5166f5e0e9c2ff8177509230d.svg";
export { ForwardRef as ReactComponent };